import { Injectable } from "@angular/core";
import { LocalConfigService } from './local-config.service';
import { user, userSession } from "../../constants/names-local.constants";
import { StringUtilsHelper } from "../../shared/helpers/strings.helper";

@Injectable({
    providedIn: 'root'
})
export class UserStorageService {
    constructor(private localConfigService: LocalConfigService) {
        
    }

    saveUser(userInfo: any){
        let usrId: string = userInfo.userId;
        this.localConfigService.saveElement(user.iduser, usrId);
        this.localConfigService.saveElement(user.username, userInfo.username);
        this.localConfigService.saveElement(user.userinfo, JSON.stringify(userInfo));
        this.localConfigService.saveElement(user.fullname, this.setFullName(userInfo));
    }

    setLock(isLock: boolean){
        this.localConfigService.saveElement(user.idle, isLock);
    }

    setFullName(user : any) : string{
        return StringUtilsHelper.createFullName(user.firstName, user.secondName, user.firstSurname, user.secondSurname);
    }

    getFullName(): string {
        return this.localConfigService.getElement(user.fullname);
    }
    getIdUser(){
        return this.localConfigService.getElement(user.iduser);
    }
    getUsername(){
        return this.localConfigService.getElement(user.username);
    }
    getUserInfo(){
        return JSON.parse(this.localConfigService.getElement(user.userinfo));
    }

    getTimeOut(){
        return this.localConfigService.getElement(userSession.inactivityTime);
    }
    
    getEndTimeBlockedSession(){
        return this.localConfigService.getElement(userSession.endTimeBlockedSession);
    }
    getLock(){
        let obj = this.localConfigService.getElement(user.idle);
        if(StringUtilsHelper.notNullOrUndefinedOrEmpty(obj)){
            return obj;
        }
        return "false";
    }

    logout(){
        this.localConfigService.removeAll();
    }

}